// part of frontend
// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ChatInterface from './components/chat/ChatInterface';
import CreateThread from './components/CreateThread';
import CreateCategory from './components/CreateCategory';
import CreateChannel from './components/CreateChannel'; // Add this import
import CreateRoom from './components/create-room/CreateRoom';
import FriendsPage from './components/friend-list/FriendsPage';
import InviteHandler from './components/InviteHandler';

import './colors.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  const [theme, setTheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    // Listen for changes in system theme preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setTheme(e.matches ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className="min-vh-100">
      <div className={`min-vh-100 ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}>
        <Router>
          <Routes>
            <Route path="/" element={<Login theme={theme} />} />
            <Route path="/login" element={<Login theme={theme} />} />{' '}
            {/* Duplicate link, for ease of navigation */}
            <Route path="/chat" element={<ChatInterface theme={theme} />} />
            <Route path="/forgot-password" element={<ForgotPassword theme={theme} />} />
            <Route path="/register" element={<Register theme={theme} />} />
            <Route path="/create-room" element={<CreateRoom theme={theme} />} />
            {/* New URL-based routes */}
            <Route path="/v/:roomUrl" element={<ChatInterface theme={theme} />} />
            <Route path="/v/:roomUrl/create-category" element={<CreateCategory theme={theme} />} />
            <Route
              path="/v/:roomUrl/create-channel/:categoryId"
              element={<CreateChannel theme={theme} />}
            />
            <Route path="/v/:roomUrl/:channelId" element={<ChatInterface theme={theme} />} />
            <Route
              path="/v/:roomUrl/:channelId/:threadId"
              element={<ChatInterface theme={theme} />}
            />
            {/* Keep create thread route but update it to match new URL pattern */}
            <Route
              path="/v/:roomUrl/:channelId/create-thread"
              element={<CreateThread theme={theme} />}
            />
            <Route path="/invite/:inviteCode" element={<InviteHandler theme={theme} />} />
            <Route path="/friends" element={<FriendsPage theme={theme} />} />
            <Route path="*" element={<Navigate to="/chat" replace />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

//frontend file structure. You can modify, but DO NOT DELETE THIS
/*
src/
  ├── hooks/
  |   ├─ useFetch.js
  |   ├─ useFriendsData.js
  |   └─ useResponsive.js
  ├── components/
  |   ├─ chat/
  |   |  ├─ ChatInterface.js
  |   |  ├─ ContextMenu.js
  |   |  ├─ ThreadList.js
  |   |  ├─ Thread.js
  |   |  └─ ChannelSidebar.js
  |   ├─ create-room/
  |   |  ├─ CreateRoom.js
  |   |  ├─ DetailsForm.js
  |   |  ├─ index.js
  |   |  ├─ Layout.js
  |   |  └─ SettingsForm.js
  |   ├─ friend-list/
  |   |  ├─ AddFriend.js
  |   |  ├─ CategoryContextMenu.js
  |   |  ├─ CreateFriendCategory.js
  |   |  ├─ DirectMessage.js
  |   |  ├─ FriendRequests.js
  |   |  ├─ FriendSidebar.js
  |   |  ├─ FriendsList.js
  |   |  ├─ FriendsPage.js
  |   |  ├─ FriendsView.js
  |   |  ├─ friendsHandlers.js
  |   |  ├─ Layout.js
  |   |  └─ index.js
  |   ├─ navigation/
  |   |  └─ MainNavigation.js
  |   ├─ CreateChannel.js
  |   ├─ CreateThread.js
  |   ├─ CreateCategory.js
  |   ├─ ForgotPassword.js
  |   ├─ Login.js
  |   ├─ Register.js
  |   └─ ResetPassword.js
  ├── App.js
  ├── config.js
  ├── index.js
  ├── setupTests.js
  └── colors.css
  */
export default App;
